export function savedItemsQueryKey(userId) {
  return ['saved-items', userId]
}

export function describeLibraryListState({ isLoading, data, error, query }) {
  const loaded = Array.isArray(data)
  const status = error?.response?.status ?? null
  const needle = String(query || '').trim()

  if (isLoading && !loaded) return 'loading'
  if (error && !loaded && status === 403) return 'forbidden'
  if (error && !loaded) return 'error'
  if (error && loaded) return 'refresh-error'
  if (loaded && data.length === 0) return 'empty'
  if (loaded && needle) {
    const visible = filterSavedItems(data, needle)
    if (visible.length === 0) return 'search-empty'
  }
  if (loaded) return 'success'
  return 'loading'
}

export function applySavedItemPatch(savedItems, savedId, payload) {
  return (Array.isArray(savedItems) ? savedItems : []).map((item) => (
    item?.id === savedId ? { ...item, ...payload } : item
  ))
}

export function isolateLibraryEdit({ savedItems, cartItems, savedId, payload }) {
  return {
    savedItems: applySavedItemPatch(savedItems, savedId, payload),
    cartItems: Array.isArray(cartItems) ? cartItems.map((item) => ({ ...item })) : [],
  }
}

export function filterSavedItems(items, query) {
  const needle = String(query || '').trim().toLowerCase()
  return (Array.isArray(items) ? items : []).filter((item) => {
    if (!needle) return true
    return (
      String(item.name || '').toLowerCase().includes(needle)
      || String(item.certainty_label || '').toLowerCase().includes(needle)
    )
  })
}
